import React from "react"

type Props = {
  isMenuTitle?:boolean
  menuTitle?: string
  children: any
  isTech?:boolean
}
const MenuItem: React.FC<Props> = ({ children, menuTitle, isTech , isMenuTitle}) => {
  return (
    <div className="menu-item">
      {
        isMenuTitle ? <p className="menu-button text-textcolor dark:text-white">{menuTitle}</p> : <p className="menu-button hidden lg:block text-textcolor dark:text-white !border-0 mb-0 !lg:pt-10 !pb-0"></p>
      }
      <div>
        <div className={isTech ? "columns-2 lg:columns-1 menu-body lg:flex flex-col lg:gap-15 mb-2.5 lg:mb-0" : "menu-body lg:flex flex-col lg:gap-15 mb-2.5 lg:mb-0"}>{children}</div>
      </div>
    </div>
  )
}

export default MenuItem
